module.exports = __webpack_public_path__ + "img/1509750338.0240d537.jpg";